export const vehicleLandingFacetField = 'Vehicle' as const;
